import type { ComputedRef, InjectionKey } from 'vue';

export type efFormProvide = {
	register: (id: string, isValid: ComputedRef<boolean>) => void;
	unregister: (id: string) => void;
	/** True when an empty required field does not hold the form back - see efForm's `allowEmpty`. */
	allowsEmpty: () => boolean;
	/** True once the form was asked to show every error, the untouched empty fields too - see efForm's `reveal`. */
	revealed: () => boolean;
};

export const efFormSymbol: InjectionKey<efFormProvide> = Symbol('efForm');
